module.exports = __webpack_public_path__ + "img/ImgBarcode.945b882b.png";